<!-- App.vue -->
<template>
  <div id="app">
    <NavigationBar />
    <!-- 智能占位元素 -->
    <div v-if="!isHomePage" class="navigation-bar-spacer"></div>
    
    <main>
      <router-view />
    </main>
    
    <EndnoteGroup v-if="!isHomePage" />
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue';
import EndnoteGroup from '@/components/EndnoteGroup.vue';

export default {
  name: 'App',
  components: {
    NavigationBar,
    EndnoteGroup
  },
  computed: {
    // 精准判断首页状态
    isHomePage() {
      return this.$route.path === '/' && !this.$route.hash;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  > main {
    flex: 1;
  }

  // 动态占位符样式
  .navigation-bar-spacer {
    height: 60px; // 与导航栏默认高度一致
    @media (max-width: 768px) {
      height: 80px; // 适配移动端导航栏高度
    }
  }
}

@media (max-width: 768px) {
  #app {
    font-size: 14px;
    > main {
      padding: 10px;
    }
  }
}
</style>
